import React, { Component } from "react";
import PaymentService from "../services/payment.service";
import EventBus from "../common/EventBus";
import RcSlider from "../common/RcSlider";
import AuthService from "../services/auth.service";
import { Navigate }from "react-router-dom";
import ReactModal from 'react-modal';
import '../css/modal.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getDay, addDays, format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { registerLocale } from 'react-datepicker';
import loading from "../img/loading.gif";
import logoelec from "../img/elec.png";
import logogaz from "../img/gaz.png";
import logo from "../img/logo-ohm-Q.png";
import cb from "../img/cb.png";
import axios from "axios";
import authHeader from "../services/auth-header";
import PaymentCustomerService from "../services/payment-customer.service";
import Input from "react-validation/build/input";
import {isEmail} from "validator";
import CheckButton from "react-validation/build/button";
import Form from "react-validation/build/form";
import etape from "../img/etape.png";
import valide from "../img/check.png";
import moment from "moment/moment";
import {confirmAlert} from "react-confirm-alert";
const tokentime = format(new Date(), "dd/MM/yyyy hh:mm:ss");
registerLocale('fr', fr);
const API_URL = process.env.REACT_APP_URL_API;
var nbrEtal=1;
var amountDetteBackup=[-1,-1,-1];
var buckupContent = false;

const required = value => {
    if (!value) {
        return (
            <div className="alert alert-danger" role="alert">
                Ce champ est obligatoire.
            </div>
        );
    }
};

const email = value => {
    if (!isEmail(value)) {
        return (
            <div className="alert alert-danger" role="alert">
                Email non valide.
            </div>
        );
    }
};

const tel = value => {
    const PHONE_REGEX = new RegExp(
        '^(?:(?:\\+|00)33[\\s.-]{0,3}(?:\\(0\\)[\\s.-]{0,3})?|0)[1-9](?:(?:[\\s.-]?\\d{2}){4}|\\d{2}(?:[\\s.-]?\\d{3}){2})$'
    );
    let resValidation =  PHONE_REGEX.test(value);

    if (!resValidation) {
        return (
            <div className="alert alert-danger" role="alert">
                Numéro de téléphone non valide.
            </div>
        );
    }
};
export default class Payment extends Component {
    blockRef0 = React.createRef();
    blockRef1 = React.createRef();
    constructor(props) {
        super(props);
        this.viewList = this.viewList.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.sendBackLink = this.sendBackLink.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.closePopupInfo = this.closePopupInfo.bind(this);
        this.closePopupListPayment = this.closePopupListPayment.bind(this);
        this.closePopupLink = this.closePopupLink.bind(this);
        this.infoPayment = this.infoPayment.bind(this);
        this.payment = this.payment.bind(this);
        this.showBloc = this.showBloc.bind(this);
        this.handleOptionChangeTypePayment = this.handleOptionChangeTypePayment.bind(this);
        this.handleOptionChangeMethodEtalement = this.handleOptionChangeMethodEtalement.bind(this);
        this.handleOptionChangeMethodPayment = this.handleOptionChangeMethodPayment.bind(this);
        this.handleOptionChangeNbrEtalement = this.handleOptionChangeNbrEtalement.bind(this);
        this.handleOptionChangeInfoEtalementForce = this.handleOptionChangeInfoEtalementForce.bind(this);
        this.handleOnChangeDateFirst = this.handleOnChangeDateFirst.bind(this);
        this.sendLink = this.sendLink.bind(this);
        this.seeLink = this.seeLink.bind(this);
        this.reportPayment = this.reportPayment.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangeTel = this.onChangeTel.bind(this);
        this.onChangeAmountUpdate = this.onChangeAmountUpdate.bind(this);
        this.handleAction = this.handleAction.bind(this);
        this.handleOptionChangeSend = this.handleOptionChangeSend.bind(this);
        this.handleTextareaChange = this.handleTextareaChange.bind(this);
        this.handleOptionChangeInfoEtalement = this.handleOptionChangeInfoEtalement.bind(this);
        this.showBlocPP1 = this.showBlocPP1.bind(this);
        this.handleSelectInvoice = this.handleSelectInvoice.bind(this);
        this.requestEnedis = this.requestEnedis.bind(this);
        this.confirmationAction = this.confirmationAction.bind(this);
        this.handleOptionChangeRetab = this.handleOptionChangeRetab.bind(this);
        this.onChangeTelEnedis = this.onChangeTelEnedis.bind(this);

        this.state = {
            content: "",
            displayBlock: false,
            block:"",
            redirect: "",
            customer: "",
            isOpen: false,
            methodPayment: "",
            typePayment: "",
            typePaymentNv2: "",
            idDette:"",
            indexDtte:"",
            hostedTokenizationUrl:"",
            htmlContent:"",
            contract:null,
            dette:false,
            methodPaymentEtalement:"",
            nbrEtalement:1,
            firstDate:format(addDays(new Date(),7), "dd/MM/yyyy"),
            dateEffet:new Date(),
            startDate:new Date(),
            messagerecovery:"",
            role:"",
            idDetteP:"",
            indexDette:"",
            infoEtalement:"",
            email:"",
            tel:"",
            backupTel:"",
            isOpenInfo:false,
            sendWith:"-",
            sendLink:true,
            message:"",
            classmessage:"",
            loading:false,
            isOpenSeeLink:false,
            listlink:false,
            sendMail:false,
            isOpenSeePayment:false,
            listPaymentWl:false,
            listPaymentPis:false,
            listPaymentOdoo:false,
            messageError:false,
            parent:"",
            comment:"",
            nbMax:1,
            amountmaxupdate:"",
            amountUpdate:"",
            errorMsgUpdateAmount:"",
            valideMsgUpdateAmount:"",
            cm:"",
            partialAmount:false,
            telContact:"",
            amountvalid:false,
            displayBlockPP1:false,
            errorPP1:false,
            infoPP1:false,
            loadingPp1:true,
            paymentCancelled:null,
            paymentType:false,
            backListInvoice:"",
            backListPayment:"",
            backPartialAmount:"",
            backupSpread:"",
            backupSpreadForceListAmount:"",
            backupSpreadForceListNbetal:"",
            backupSpreadForce:"",
            backupP0calc:"",
            listRefInvoiceAnticip:[],
            loadingAnticip:false,
            force:false,
            countComment:0,
            infoEnedis:false,
            selectedOptionRetab:'oui',
            idProcessEnedis:false,
            retourEnedis:false,
            errorTelEnedis:false
        };


    }
    handleSelectInvoice(event){
        var contentAnticipeJs = JSON.parse(this.state.content);
        var listRefInvoiceAnticipJs = this.state.listRefInvoiceAnticip;
        var dettes = event.target.dataset.dettes;
        this.setState({loadingAnticip:true});
        if(this.state.listRefInvoiceAnticip.includes(event.target.value)){
            //console.log(event.target.dataset.contract);
            contentAnticipeJs[event.target.dataset.contract].dunning.actif = (contentAnticipeJs[event.target.dataset.contract].dunning.actif*1 - event.target.dataset.amount*1).toFixed(2);
            listRefInvoiceAnticipJs = listRefInvoiceAnticipJs.filter(item => item !== event.target.value);
            this.setState({listRefInvoiceAnticip : listRefInvoiceAnticipJs});
        }else{
            //console.log(event.target.dataset.contract);
            contentAnticipeJs[event.target.dataset.contract].dunning.actif = (contentAnticipeJs[event.target.dataset.contract].dunning.actif*1 + event.target.dataset.amount*1).toFixed(2);
            listRefInvoiceAnticipJs=listRefInvoiceAnticipJs.concat(event.target.value);
            this.setState({listRefInvoiceAnticip : listRefInvoiceAnticipJs});
        }
        this.setState({ infoEtalement: "", typePayment:"", methodPayment:"" , startDate:addDays(new Date(),7), firstdate:format(addDays(new Date(),7), "dd/MM/yyyy"), nbrEtalement:1});
        PaymentService.getInfoSpreadAnticipated(this.state.cm,
            contentAnticipeJs[event.target.dataset.contract].contractRef,
            contentAnticipeJs[event.target.dataset.contract].dunning.or,
            contentAnticipeJs[event.target.dataset.contract].dunning.invoice_list,
            listRefInvoiceAnticipJs, dettes).then(
            response => {
                contentAnticipeJs[event.target.dataset.contract].dunning.spread = response.data.spread;
                contentAnticipeJs[event.target.dataset.contract].dunning.spread_force_list_amount = response.data.spread_force_list_amount;
                contentAnticipeJs[event.target.dataset.contract].dunning.spread_force_list_nbetal = response.data.spread_force_list_nbetal;
                contentAnticipeJs[event.target.dataset.contract].dunning.spread_payment_force = response.data.spread_force;
                contentAnticipeJs[event.target.dataset.contract].dunning.p0calc = response.data.p0calc;
                contentAnticipeJs[event.target.dataset.contract].dunning.partialAmount =response.data.partialAmount;
                this.setState({ content: JSON.stringify(contentAnticipeJs) });
                this.setState({ contract: contentAnticipeJs[event.target.dataset.contract] });
                this.setState({loadingAnticip:false});
                //console.log(response.data.partialAmount);
            },
            error => {
                console.log(error.response);
            }
        );

    }
    handleTextareaChange(event) {

        this.setState({
            comment: event.target.value,
            countComment: event.target.value.length // Mettez à jour le state avec la valeur du textarea
        });
    }
    handleOptionChangeRetab(e){
        this.setState({
            selectedOptionRetab: e.target.value,
        });
        if(e.target.value==='oui'){
            this.setState({
                dateEffet: new Date(),
            });
        }

        if(e.target.value==='non'){
            this.setState({
                dateEffet: addDays(new Date(),1),
            });
        }


    }
    handleOptionChangeSend(e){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({
            sendWith: e.target.value
        });
        let info = JSON.parse(this.state.customer);
        let email = info.adressemail;
        let sms = info.tel;
        this.setState({email: email, tel:sms, backupTel:sms});
    }
    onChangeEmail(e) {
        this.setState({
            email: e.target.value
        });
    }

    onChangeAmountUpdate(e) {
        let value = e.target.value *1;
        var amountTotal;
        if(e.target.options!== undefined){
            amountTotal = e.target.options[e.target.selectedIndex].dataset.amounttotal*1;
        }else{
            amountTotal = e.target.dataset.amounttotal*1;
        }

        let amountMin = e.target.dataset.amountmin*1;
        let minval = Math.min(amountMin,amountTotal).toFixed(2);
        this.setState({
            errorMsgUpdateAmount: "",
            valideMsgUpdateAmount: "",
            nbrEtalement:0,
            amountUpdate:""
        });
        localStorage.setItem("nbrEtalement",0);

        // Expression régulière pour valider le format float
        const floatRegex = /^-?\d*(\.\d+)?$/;

        // Vérification

        if (!floatRegex.test(value)) {
            this.setState({
                errorMsgUpdateAmount: "La valeur doit être un nombre avec 2 décimales maximum."
            });
        }else{
            if(value<minval){
                this.setState({
                    errorMsgUpdateAmount: "Le montant minimum est "+minval+" euros."
                });
            }else{
                if(value>amountTotal){
                    this.setState({
                        errorMsgUpdateAmount: "Le montant maximum est "+amountTotal+" euros."
                    });
                }else {
                    this.setState({
                        partialAmount: value,
                        amountUpdate:value,
                        valideMsgUpdateAmount: "Vous resterez redevable de "+(amountTotal-value).toFixed(2)+" euros."
                    });
                    localStorage.setItem("partialAmount",value);

                }
            }
        }

    }

    handleOptionChangeInfoEtalement(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        setTimeout(() => {
            this.infoPayment(this.state.customer, this.state.contract, this.state.nbrEtalement, this.state.partialAmount, format(this.state.startDate,"dd/MM/yyyy"), this.state.listRefInvoiceAnticip).then(
                response => {

                    this.setState({
                        infoEtalement: JSON.stringify(response.data)
                    });

                });
        }, 1000);

    }

    handleOptionChangeInfoEtalementForce(e){
        nbrEtal = e.target.options[e.target.selectedIndex].dataset.nbrmax;
        this.setState({
            partialAmount:e.target.value,
            nbMax:e.target.options[e.target.selectedIndex].dataset.nbrmax
        });
        localStorage.setItem("partialAmount",e.target.value);

        this.infoPayment(this.state.customer, this.state.contract, this.state.nbrEtalement , e.target.value, format(this.state.startDate,"dd/MM/yyyy"), this.state.listRefInvoiceAnticip).then(
            response => {

                this.setState({
                    infoEtalement: JSON.stringify(response.data)
                });

            });
    }
    onChangeTelEnedis(e) {

        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({
            tel: e.target.value
        });
        if(!e.target.value) {
            this.setState({
                errorTelEnedis: "Ce champ est obligatoire."
            });
        }else {
            const PHONE_REGEX = new RegExp(
                '^(?:(?:\\+|00)33[\\s.-]{0,3}(?:\\(0\\)[\\s.-]{0,3})?|0)[1-9](?:(?:[\\s.-]?\\d{2}){4}|\\d{2}(?:[\\s.-]?\\d{3}){2})$'
            );
            let resValidation = PHONE_REGEX.test(e.target.value);

            if (!resValidation) {
                this.setState({
                    errorTelEnedis: "Numéro de téléphone non valide."
                });
            }else{
                this.setState({
                    errorTelEnedis:false
                });
            }
        }

    }

    onChangeTel(e) {
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({
            tel: e.target.value
        });


    }
    recevoirValeurAmountSpreadForce = (valeur) => {
        this.setState({ partialAmount: valeur });
        localStorage.setItem("partialAmount",valeur);
    }
    recevoirNbrMaxSpreadForce = (valeur) => {
        nbrEtal = valeur;
    }

    sendBackLink(e){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        let token = e.target.dataset.token;
        this.setState({sendMail:true})
        PaymentCustomerService.sendMail(token).then(
            response => {
                this.setState({sendMail:false});
            },
            error =>{
                console.log('not ok');
            }
            );

    }
    payment(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        PaymentService.getIframeWorldline().then(
            response => {
                this.setState({
                    hostedTokenizationUrl: response.data.hostedTokenizationUrl,
                    hostedTokenizationId: response.data.hostedTokenizationId
                });
                localStorage.setItem("hostedTokenizationUrl", response.data.hostedTokenizationUrl);
                localStorage.setItem("API_URL", API_URL);
                localStorage.setItem("contract", JSON.stringify(this.state.contract));
                localStorage.setItem("methodPaiment", this.state.methodPayment);
                localStorage.setItem("methodPaymentSpread", this.state.methodPaymentEtalement);
                localStorage.setItem("comment", this.state.comment);
                localStorage.setItem("pp1", (this.state.displayBlockPP1===true ? 1 : null));
                localStorage.setItem("listRefInvoiceAnticip", this.state.listRefInvoiceAnticip);

            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
        this.setState({ isOpen: true });
    }

    sendLink(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        let info = JSON.parse(this.state.customer);
        this.setState({isOpenInfo: true, email: info.adressemail, tel:info.tel});
    }
    viewList(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({ parent: index.target.dataset.parent });
    }

    reportPayment(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({isOpenSeePayment:true});
        this.setState({
            listPaymentOdoo: false,
            listPaymentWl: false,
            listPaymentPis:false
        });
        PaymentService.getListPayment(localStorage.getItem("processId")).then(
            response => {
                this.setState({
                    listPaymentOdoo: response.data.paymentOdoo,
                    listPaymentWl: response.data.paymentWl,
                    listPaymentPis: response.data.paymentPis,
                    messageError:response.data.error
                });
            },
            error => {
                this.setState({
                    listPaymentOdoo: false,
                    listPaymentWl: false,
                    listPaymentPis: false
                });
            }
        );

    }
    seeLink(){

        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({listlink: false});
        PaymentCustomerService.getLinksPayment(
            localStorage.getItem("customer"),
            JSON.stringify(this.state.contract)
        ).then(
            response => {
                let res = response.data;
                if(res){
                    this.setState({listlink: res});
                }else{
                    this.setState({listlink: []});
                }

            },
            error => {
                this.setState({listLink:false});
            }
        );
        this.setState({isOpenSeeLink: true});
    }
    handleAction(e){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({loading:true,amountvalid : true})
        e.preventDefault();
        this.form.validateAll();
        if (this.checkBtn.context._errors.length === 0) {
        PaymentCustomerService.addPaymentCustomer(
            localStorage.getItem("customer"),
            JSON.stringify(this.state.contract),
            this.state.partialAmount ? this.state.partialAmount : this.state.contract.dunning.actif,
            localStorage.getItem("processId"),
            localStorage.getItem("origine"),
            localStorage.getItem("firstDate"),
            (this.state.methodPayment==="piccb" || this.state.methodPayment==="picvir") ? 0 : localStorage.getItem("nbrEtalement"),
            this.state.methodPayment,
            this.state.partialAmount ? this.state.methodPaymentEtalement : "",
            this.state.email,
            this.state.tel,
            this.state.backupTel,
            this.state.sendWith,
            this.state.displayBlockPP1 ? 1 : null,
            this.state.listRefInvoiceAnticip,
            localStorage.getItem("force"),
            this.state.comment
        ).then(
            response => {
                this.setState({sendLink: false, message: "Le lien est bien envoyé au client.", classmessage:"success", loading:false});

            },
            error => {
                this.setState({sendLink: false, message: "Il y'a un probléme technique merci de contacter le support technique.", classmessage:"error", loading:false});
            }
        );}

    }
    showBlocPP1(index){

        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }

        localStorage.setItem("VALIDE_PAYMENT","NOK");

        this.setState({ idDette: index.target.dataset.id, block:(index.target.dataset.contract*1===0 ? this.blockRef0 : this.blockRef1)});
        this.setState({ idDetteP: "" });
        this.setState({ loadingPp1: true });
        this.setState({ amountvalid: false });
        this.setState({ displayBlock: true });
        this.setState({ displayBlockPP1: true });
        this.setState({ errorPP1: false });
        this.setState({ indexDette: index.target.dataset.contract });
        this.setState({ contract: JSON.parse(localStorage.getItem("contracts"))[index.target.dataset.contract]});
        PaymentService.getInfoAmountPP1(
            JSON.parse(localStorage.getItem("contracts"))[index.target.dataset.contract].contractRef,
            this.state.cm).then(
            response => {
                if(response.data.infoPayment[0]===false){
                    this.setState({ errorPP1: true });
                }else{
                    this.setState({ infoPP1: response.data.infoContract, loadingPp1:false });
                    this.setState({ partialAmount: response.data.infoContract[1] });
                    this.setState({ paymentCancelled: response.data.infoPayment[2] });
                    localStorage.setItem("partialAmount",response.data.infoContract[1]);
                    PaymentService.startProcess(
                        JSON.parse(localStorage.getItem("contracts"))[index.target.dataset.contract],
                        this.state.customer,
                        AuthService.getCurrentUser().userid,
                        localStorage.getItem("origine"),
                        1,
                        JSON.stringify(response.data),
                        0
                    ).then(
                        response => {
                            localStorage.setItem("processId", response.data);
                        },
                        error => {
                            this.setState({
                                content:
                                    (error.response &&
                                        error.response.data &&
                                        error.response.data.message) ||
                                    error.message ||
                                    error.toString()
                            });

                            if (error.response && error.response.status === 401) {
                                EventBus.dispatch("logout");
                            }
                        }
                    );
                }
            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
    }
    showBloc(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        var contentAnticipe = JSON.parse(this.state.content);

        if(buckupContent===false){
            buckupContent = this.state.content;
        }


        if(index.target.dataset.type==="anticipe") {
            this.setState({paymentType: "anticipe"});
            this.setState({listRefInvoiceAnticip: contentAnticipe[index.target.dataset.contract].anticipated.refInvoice});
            if(amountDetteBackup[index.target.dataset.contract]===-1){
                amountDetteBackup[index.target.dataset.contract] = contentAnticipe[index.target.dataset.contract].dunning.actif ;
            }

            contentAnticipe[index.target.dataset.contract].dunning.actif = contentAnticipe[index.target.dataset.contract].anticipated.sumAmountInvoice;
            contentAnticipe[index.target.dataset.contract].dunning.invoice_list = contentAnticipe[index.target.dataset.contract].anticipated.invoice;
            contentAnticipe[index.target.dataset.contract].dunning.payment_list = [];
            contentAnticipe[index.target.dataset.contract].dunning.partialAmount = contentAnticipe[index.target.dataset.contract].anticipated.infospread.partialAmount;

            contentAnticipe[index.target.dataset.contract].dunning.spread = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread;
            contentAnticipe[index.target.dataset.contract].dunning.spread_force_list_amount = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread_force_list_amount;
            contentAnticipe[index.target.dataset.contract].dunning.spread_force_list_nbetal = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread_force_list_nbetal;
            contentAnticipe[index.target.dataset.contract].dunning.spread_payment_force = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread_force;
            contentAnticipe[index.target.dataset.contract].dunning.p0calc = contentAnticipe[index.target.dataset.contract].anticipated.infospread.p0calc;
            this.setState({ content: JSON.stringify(contentAnticipe) });
        }else{
            this.setState({paymentType: "dettes"});
            this.setState({listRefInvoiceAnticip: ""});
            this.setState({ content: buckupContent });
        }

        localStorage.setItem("VALIDE_PAYMENT","NOK");
        localStorage.setItem("pp1",0);
        localStorage.setItem("force",0);
        this.setState({ displayBlockPP1: false });
        this.setState({ infoEnedis: false });
        this.setState({ idDette: index.target.dataset.id, block:(index.target.dataset.contract*1===0 ? this.blockRef0 : this.blockRef1)});
        this.setState({ idDetteP: "" });
        this.setState({ amountvalid: false });
        this.setState({ force: false });
        this.setState({ displayBlock: true });
        this.setState({ infoEtalement: "", typePayment:"", methodPayment:"" , startDate:addDays(new Date(),7), firstdate:format(addDays(new Date(),7), "dd/MM/yyyy"), nbrEtalement:1});
        this.setState({ indexDette: index.target.dataset.contract });
        this.setState({ contract: contentAnticipe[index.target.dataset.contract]});
        PaymentService.startProcess(
            JSON.parse(localStorage.getItem("contracts"))[index.target.dataset.contract],
            this.state.customer,
            AuthService.getCurrentUser().userid,
            localStorage.getItem("origine"),
            0,
            "",
            index.target.dataset.type==="anticipe" ? 1 : 0
        ).then(
            response => {
                localStorage.setItem("processId", response.data);
            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );

    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.displayBlock) {
            this.scrollToBottom(this.state.block);
            this.setState({displayBlock: false});
        }
        if (this.state.infoEnedis) {
            this.scrollToBottom(this.state.block);
        }
    }
    handleOptionChangeTypePayment(index) {
        if (tokentime !== localStorage.getItem("tokentime")) {
            window.location.replace("/create_payment");
        }

        if(index.target.dataset.force==="true"){
            this.setState({force: true});
            localStorage.setItem("force", 1);
        }else{
            this.setState({force: false});
            localStorage.setItem("force", 0);
        }


        if (!this.state.amountvalid) {
            if (index.target.dataset.val) {
                this.setState({typePayment: index.target.dataset.val});
            }

            if (index.target.dataset.val === "pic" || index.target.dataset.val === "picvir" || index.target.dataset.methodpayment === "piccb") {
                this.setState({nbrEtalement: 0});
                localStorage.setItem("nbrEtalement", 0);
            } else {
                this.setState({nbrEtalement: 1});
                localStorage.setItem("nbrEtalement", 1);
            }

            this.setState({infoEtalement: ""});

            this.setState({methodPayment: index.target.dataset.methodpayment});

            this.setState({amountUpdate: ""});
            this.setState({methodPaymentEtalement: ""});
            this.setState({valideMsgUpdateAmount: ""});
            if(index.target.dataset.force==="true") {
                nbrEtal = 1;
            }else{
                nbrEtal = index.target.dataset.nbretal;
            }

            if(this.state.displayBlockPP1===false){
                localStorage.setItem("partialAmount", index.target.dataset.partialamount);
                this.setState({partialAmount: index.target.dataset.partialamount});
            }

        }
    }
    handleOptionChangeNbrEtalement(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({ nbrEtalement: index.target.value, parent:"" });
        localStorage.setItem("nbrEtalement", index.target.value);
        this.infoPayment(this.state.customer, this.state.contract, index.target.value, this.state.partialAmount, format(this.state.startDate,"dd/MM/yyyy"),this.state.listRefInvoiceAnticip).then(
            response => {

                this.setState({
                    infoEtalement: JSON.stringify(response.data)
                });

            });
    }


    handleOnChangeDateFirst(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        localStorage.setItem("firstDate", index.target.value);

    }
    handleOptionChangeMethodEtalement(index){

        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        if(!this.state.amountvalid){
            this.setState({ methodPaymentEtalement: index.target.dataset.val });
        }

    }

    handleOptionChangeMethodPayment(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        if(index.target.value==='pipcb'){
                localStorage.setItem("partialAmount",index.target.dataset.partialamount);
        }else{
            localStorage.setItem("partialAmount",false);
        }
        this.setState({ methodPayment: index.target.value });

    }

    infoPayment(customer, contract, nbrEtallement, partialPayment, firstDateEtalement,listFilterInvoice){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        return axios.post(API_URL + "payment/info", {
            customer,
            contract,
            nbrEtallement,
            partialPayment,
            firstDateEtalement,
            listFilterInvoice
        },{ headers: authHeader() });
    }
    closePopupListPayment(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({isOpenSeePayment:false});
    }
    closePopupInfo(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({isOpenInfo:false, sendWith:"-", sendLink: true});
    }
    closePopupLink() {
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({isOpenSeeLink:false});
    }
    closePopup(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({isOpen:false});
        this.setState({
            listPaymentOdoo: false,
            listPaymentWl: false,
            listPaymentPis: false
        });
        if(localStorage.getItem("VALIDE_PAYMENT")==="OK"){
            window.location.replace("/create_payment");
            /*
            let updateContacts = JSON.parse(localStorage.getItem("contracts"));
            this.setState({idDetteP:this.state.idDette});
            this.setState({idDette: -1});
            if(updateContacts[this.state.indexDette].dunning.actif-this.state.amountUpdate>0) {
                OdooService.getContractsCustomer(this.state.cm).then(
                    () => {
                        this.setState({
                            successful: true,
                            nextPage: "/info_payment",
                            loading:false,
                            content: localStorage.getItem("contracts")
                        });
                    },
                    error => {
                        const resMessage =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();

                        this.setState({
                            loading: false,
                            message: resMessage
                        });
                    }
                );
            }
            PaymentService.getListPayment(localStorage.getItem("processId")).then(
                response => {
                    this.setState({
                        listPaymentOdoo: response.data.paymentOdoo,
                        listPaymentWl: response.data.paymentWl,
                        messageError:response.data.error
                    });
                },
                error => {
                    this.setState({
                        listPaymentOdoo: [],
                        listPaymentWl: []
                    });
                }
            );
            this.setState({isOpenSeePayment:true});

             */

        }

    }
    scrollToBottom = (block) => {
        block.current.scrollIntoView({ behavior: 'smooth' });
    };

    componentDidMount() {
        const currentUser = AuthService.getCurrentUser();
        buckupContent = false;
        localStorage.setItem("tokentime", tokentime);

        if (!currentUser) {
            AuthService.logout();
        }
        this.setState({idDetteP: ""});
        this.setState({role: currentUser.roles[0]});
        localStorage.setItem("VALIDE_PAYMENT", "NOK");
        localStorage.setItem("force", 0);
        this.setState({content: localStorage.getItem("contracts")});
        this.setState({customer: localStorage.getItem("customer")});
        this.setState({cm:JSON.parse(localStorage.getItem("customer")).refCustomer});
        this.setState({telContact:(JSON.parse(localStorage.getItem("customer")).refCustomer[0] + JSON.parse(localStorage.getItem("customer")).refCustomer[1] === "CM" ? "09 70 70 21 25" : "01 76 49 78 88")});
        this.setState({messagerecovery: localStorage.getItem("messagerecovery")});
        localStorage.setItem("partialAmount", false);
        localStorage.setItem("nbrEtalement", 1);
        localStorage.setItem("firstDate", format(addDays(new Date(),7), "dd/MM/yyyy"));
        if(!localStorage.getItem("origine")){
            localStorage.setItem("origine","MARQUE_BLANCHE_OHM");
        }
    }
    confirmValidAction(processId){
        this.setState({loading:true})
        PaymentService.executProcessEnedis(
            processId
        ).then(
            response => {
                this.setState({retourEnedis: response.data,loading:false});
            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
    }
    confirmationAction() {
        PaymentService.updateProcessEnedis(this.state.idProcessEnedis,this.state.tel.replace(/\s/g,''), format(new Date(this.state.dateEffet), "yyyy-MM-dd"));
        confirmAlert({
            title: 'Confirmation',
            message: 'Voulez-vous vraiment valider cette action ?',
            buttons: [
                {
                    label: 'Oui',
                    onClick: () => this.confirmValidAction(this.state.idProcessEnedis)
                },
                {
                    label: 'Non',
                    onClick: () => this.setState({loading:false})
                }
            ]
        });
    }
    requestEnedis(index){
        let info = JSON.parse(this.state.customer);
        let numtel = info.tel;
        PaymentService.startProcessEnedis(
            this.state.customer,
            JSON.parse(localStorage.getItem("contracts"))[index.target.dataset.contract],
            AuthService.getCurrentUser().userid,
            index.target.dataset.request,
            index.target.dataset.typerequest,
            localStorage.getItem("origine"),
            index.target.dataset.pce
        ).then(
            response => {
                this.setState({
                    infoEnedis:true,
                    idDette:index.target.dataset.id,
                    tel:numtel,
                    idProcessEnedis:response.data,
                    block:(index.target.dataset.contract*1===0 ? this.blockRef0 : this.blockRef1)
                })
            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );

    }

    render() {
        const heureActuelle = new Date();
        const heureLimite = new Date();
        const heureLimiteCancel = new Date();
        heureLimite.setHours(14, 50, 0, 0);
        heureLimiteCancel.setHours(16, 50, 0, 0);
        const estAvantLimite = heureActuelle <= heureLimite;
        const estAvantLimiteCancel = heureActuelle <= heureLimiteCancel;
        const handleDateChange = (date) => {
            this.setState({startDate: date, firstDate:format(date, "dd/MM/yyyy"), parent:""});
            localStorage.setItem("firstDate", format(date, "dd/MM/yyyy"));
            this.infoPayment(this.state.customer, this.state.contract, this.state.nbrEtalement, this.state.partialAmount, format(date, "dd/MM/yyyy"),this.state.listRefInvoiceAnticip).then(
                response => {

                        this.setState({
                            infoEtalement: JSON.stringify(response.data)
                        });

                });
        };

        const handleDateChangeEnedis = (date) => {
            this.setState({dateEffet: date});

        };

        const isWeekday = (date) => {
            const day = getDay(date);
            return day !== 0 && day !== 6;
        };
        if (this.state.redirect) {
            return <Navigate to={this.state.redirect} />
        }
        let items  = [];
        if(this.state.content){
            items = JSON.parse(this.state.content);
        }
        let customer = "";
        if(this.state.customer){
            customer = JSON.parse(this.state.customer);
        }
        let messagerecovery = "";
        if(this.state.messagerecovery){
            messagerecovery = JSON.parse(this.state.messagerecovery);
        }

        let infoEtalementTab = [];
        if(this.state.infoEtalement){
            infoEtalementTab = JSON.parse(this.state.infoEtalement);
        }

        return (
            <div className="col-md-12">
                { (this.state.customer==="") &&
                    <header className="jumbotron">

                        <img className="loading" alt={"loading"}
                             src={loading}/>
                    </header>
                }
                { (this.state.customer!=="") &&
                <header className="jumbotron">
                    <div className="circle-container circle-customer">
                        <div className="circle-text">
                            <span>
                                {customer.firstname[0] + customer.lastname[0]}
                            </span>
                        </div>
                    </div>
                    <div>
                        <span className="name">
                            { customer.firstname + " " + customer.lastname }
                        </span>
                    </div>
                    <div className="trait"></div>
                    <span className="cm">
                        {customer.refCustomer}
                    </span>
                </header>
                }


                { (this.state.contracts!=="") &&
                <div className="App">

                    {items.map((val, key) => {
                        return (

                            <div className="row row-payment"  key={val.id}>
                                <div className="col-12" >
                                    <div className="col-12 info-payment">
                                        <div className="circle-container circle-contract">
                                            <div className="circle-text">
                                                <img className="logotypecontact" alt={"Type contrat"}
                                                     src={val.energyType==="EL" ? logoelec : (val.energyType==="NG" ? logogaz : logo)}/>
                                            </div>
                                        </div>
                                        <h3>{val.contractRef}</h3>
                                        <div className="info-contract">
                                            <ul>
                                                <li>
                                                    <span className="titre">Energie :</span>
                                                    <span className="info"> {val.energyType==="EL" ? "Electricité" : (val.energyType==="NG" ? "GAZ Naturel" : val.energyType)}</span>
                                                </li>
                                                <li>
                                                    <span className="titre">Statut du contrat :</span>
                                                    <span className="info"> {val.status}</span>
                                                </li>
                                                <li>
                                                    <span className="titre">Adresse du point de livraison :</span>
                                                    <span className="info"> {val.adress}</span>
                                                </li>
                                                {(val.status==="Terminé" || val.status==="Actif")&&
                                                    <>
                                                <li>
                                                    <span className="titre">Dettes actives :</span>
                                                    <span className="info"> {amountDetteBackup[key] > -1 ? amountDetteBackup[key] : val.dunning.actif} &euro;</span>
                                                </li>
                                                {(this.state.role!=="ROLE_CUSTOMER")&&
                                                <li>
                                                    <span className="titre">Dettes en pause :</span>
                                                    <span className="info"> {val.dunning.paused} &euro;</span>
                                                </li>
                                                }
                                                {(this.state.role==="ROLE_CUSTOMER" && val.dunning.paused>0)&&
                                                    <li>
                                                        <span className="titre">Dettes en pause :</span>
                                                        <span className="info"> {val.dunning.paused} &euro;</span>
                                                    </li>
                                                }
                                                {(val.dunning.actif>0)&&
                                                <li>
                                                    <span className="titre">Etape du recouvrement :</span>
                                                    <span className="info"> {messagerecovery ? messagerecovery : "Pas d'information."}</span>
                                                </li>
                                                }
                                                {(val.energyType==="EL" && val.enedis && val.enedis.body.onGoingInterventions.situationAlimentation) &&
                                                <li>
                                                    <span className="titre">Etat du point :</span>
                                                    <span className="info"> {val.enedis.body.onGoingInterventions.situationAlimentation}</span>
                                                </li>
                                                }
                                                </>
                                                }
                                                {
                                                    (val.energyType==="EL" && val.enediserror ) &&
                                                    <div className="col-12">
                                                        <div className="info-contract">
                                                            <span className="info import"> {val.enediserror}</span>
                                                        </div>
                                                    </div>

                                                }
                                                {
                                                    (val.energyType==="EL" && val.enedis && val.enedis.body.onGoingInterventions.libelle) &&
                                                        <div className="col-12">
                                                            <div className="info-contract">
                                                                <h3  className="import">Demande en cours auprès d'Enedis</h3>
                                                                <span className="titre">Demande :</span><span className="info import"> {val.enedis.body.onGoingInterventions.libellePers}</span><br/>
                                                                <span className="titre">Type compteur :</span><span className="info import"> {val.enedis.body.onGoingInterventions.openingLevel*1===2 ? "Communiquant":"Non communiquant" }</span><br/>
                                                            </div>
                                                        </div>

                                                }
                                                {(val.status!=="Terminé" && val.status!=="Actif")&&
                                                    <li>
                                                        <span className="titre">Date prévue d’activation :</span>
                                                        <span className="info"> {val.contractualStartDate}</span>
                                                    </li>
                                                }
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                                { ((amountDetteBackup[key]>0 || (val.dunning.actif>0 && amountDetteBackup[key]===-1) ) && (val.status==="Terminé" || val.status==="Actif")) &&
                                <div className="col-lg-6 col-md-6 col-sm-12 block-info-payment" >
                                    <div className="col-12 info-payment info-dette">
                                        <h3  className="import">Gérer les dettes</h3>
                                        <div className="info-contract">
                                            <span className="titre">Dettes actives :</span><span className="info import"> {amountDetteBackup[key] >-1 ? amountDetteBackup[key] : val.dunning.actif} &euro;</span><br/>
                                        </div>
                                        <button id={"bloc"+val.id} data-id={val.id} data-contract={key} onClick={this.showBloc} className="ohm-btn-payment btn btn-block">Régulariser la situation</button>

                                    </div>
                                </div>
                                }

                                {
                                    (val.energyType==="EL" && val.enedis && val.enedis.body.onGoingInterventions.libelle) &&
                                    <div className="col-lg-6 col-md-6 col-sm-12 block-info-payment" >
                                        <div className="col-12 info-payment info-dette">
                                            <h3  className="import">{val.enedis.body.onGoingInterventions.nbrDemande>0 ? 'Demande en cours' : 'Processus Enedis'}</h3>
                                            <div className="info-contract">
                                                <span className="titre">{val.enedis.body.onGoingInterventions.nbrDemande>0 ? val.enedis.body.onGoingInterventions.libellePers : ""}</span><br/>
                                            </div>
                                            {
                                                ((val.enedis.body.onGoingInterventions.situationAlimentation==="Coupé" || val.enedis.body.onGoingInterventions.situationAlimentation==="Limité") && val.enedis.body.onGoingInterventions.codeDemande==="F200BO3") ?
                                                    <span></span>
                                                    : <div>{
                                                        (val.dunning.en==="btn" || customer.en==="btn") ?
                                                <button id={"bloc"+val.id}
                                                disabled={this.state.retourEnedis===false ? false : true}
                                                data-request={val.enedis.body.onGoingInterventions.affaireId}
                                                data-typerequest={val.enedis.body.onGoingInterventions.typeRequest}
                                                data-id={val.id} data-contract={key}
                                                data-pce={val.enedis.body.onGoingInterventions.pointId}
                                                onClick={this.requestEnedis} className="ohm-btn-payment btn btn-block">{val.enedis.body.onGoingInterventions.libelleBoutton}</button> :
                                                            <button className="ohm-btn-payment btn btn-block" disabled={true}>
                                                                <span>{val.enedis.body.onGoingInterventions.libelleBoutton}</span><br/>
                                                                {(customer.en ==="msgAll") ? <span><b>Les dettes de tous les contrats doivent être soldées</b></span> :  <span><b>Les dettes du contrat doivent être soldées</b></span>}
                                                            </button>
                                                    }
                                                    </div>


                                            }


                                        </div>
                                    </div>

                                }

                                { ((val.anticipated.sumAmountInvoice > 0) && (val.status==="Terminé" || val.status==="Actif")) &&
                                    <div className="col-lg-6 col-md-6 col-sm-12 block-info-payment" >
                                        <div className="col-12 info-payment info-dette">
                                            <h3  className="import">Paiement de vos factures en cours</h3>
                                            <div className="info-contract">
                                                <span className="titre">Montant :</span><span className="info import"> {val.anticipated.sumAmountInvoice} &euro;</span><br/>
                                            </div>
                                            <button data-type="anticipe" id={"bloc"+val.id} data-id={val.id} data-contract={key} onClick={this.showBloc} className="ohm-btn-payment btn btn-block">Anticiper et trouver une solution</button>

                                        </div>
                                    </div>
                                }

                                {(val.status!=="Terminé" && val.status!=="Actif")&&
                                    <div className="col-lg-4 col-md-6 col-sm-12 block-info-payment" >
                                        <div className="col-12 info-payment info-dette">
                                            <h3  className="import">Mise en service anticipée</h3>
                                            <div className="info-contract">
                                                <span className="titre">Date d’activation prévue :</span><span className="info import"> {val.contractualStartDate}</span><br/>
                                            </div>
                                            <button id={"bloc"+val.id} data-id={val.id} data-contract={key} onClick={this.showBlocPP1} className="ohm-btn-payment btn btn-block">Procéder au premier prélèvement</button>

                                        </div>
                                    </div>
                                }

                                { (val.dunning.actif <=0 && val.anticipated.sumAmountInvoice<=0 && (val.status==="Terminé" || val.status==="Actif") && ((val.enedis && !val.enedis.body.onGoingInterventions.libelle && val.energyType==="EL") || (val.energyType==="NG" || !val.enedis) )) &&
                                    <div className="col-12 block-info-payment" >
                                        <div className="col-12 info-payment">
                                            <span><b>Tout a l’air en ordre, si vous rencontrez un problème contactez notre service client par téléphone au {this.state.telContact} ou sur internet : </b></span><a href="https://espace-client.ohm-energie.com/">Espace Client</a>
                                        </div>
                                    </div>
                                }

                                { (this.state.idDetteP*1===val.id*1) &&
                                    <div className="col-12 block-info-payment" >
                                        <div className="col-12 info-payment color-ohm">
                                            <h3>Dettes payées avec succès. </h3>
                                        </div>
                                    </div>
                                }

                                { ((val.id*1===this.state.idDette*1) && (this.state.errorPP1===true && this.state.displayBlockPP1===true)) &&
                                    <div className="col-12 block-info-payment" >
                                        <div className="col-12 info-payment">
                                            <span><b>Ce contrat n’est plus éligible à une mise en service express, si vous rencontrez un problème contactez notre service client par téléphone au {this.state.telContact} ou sur internet : </b></span><a href="https://espace-client.ohm-energie.com/">Espace Client</a>
                                        </div>
                                    </div>
                                }
                                { (this.state.infoEnedis && val.id*1===this.state.idDette*1) &&
                                    <div className="col-12 info-payment info-dette info-dette-active" >
                                        {val.enedis.body.onGoingInterventions.situationAlimentation==="Alimenté" &&
                                            <>
                                                <div className="form-group">
                                                    {val.enedis.body.onGoingInterventions.nbrDemande>0 &&
                                                        <div className="col-12">
                                                            <table className="table">
                                                                <thead>
                                                                <tr>
                                                                    <th scope="col">Demande en cours</th>
                                                                    <th scope="col">Date d'effet</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {   val.enedis.body.onGoingInterventions.listeEncours &&
                                                                    val.enedis.body.onGoingInterventions.listeEncours.map((demande, index) =>
                                                                        <tr  key={index}>
                                                                            <td>{demande.message}</td>
                                                                            <td>{demande.date}</td>
                                                                        </tr>
                                                                    )

                                                                }
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    }
                                                    {(val.enedis.body.onGoingInterventions.openingLevel*1===2) &&
                                                        <>
                                                    {(val.enedis.body.onGoingInterventions.nbrjourRestants*1<1 || (val.enedis.body.onGoingInterventions.nbrjourRestants*1===1 && !estAvantLimiteCancel))&&
                                                        <div className="message-enedis">
                                                            <span>- Il est trop tard pour faire annuler la demande, procédez à un rétablissement et/ou contactez notre service client.</span>
                                                        </div>
                                                    }
                                                    {(val.enedis.body.onGoingInterventions.nbrjourRestants*1>1 || (val.enedis.body.onGoingInterventions.nbrjourRestants*1===1 && estAvantLimiteCancel)
                                                        ) &&
                                                    <>
                                                        {this.state.retourEnedis===false &&
                                                            <>
                                                        <button id={"bloc"+val.id}
                                                                data-request={val.enedis.body.onGoingInterventions.affaireId}
                                                                data-typerequest={val.enedis.body.onGoingInterventions.typeRequest}
                                                                data-id={val.id} data-contract={key} onClick={this.confirmationAction}
                                                                className="ohm-btn-payment btn btn-send-link col-6">{val.enedis.body.onGoingInterventions.libelleBoutton}
                                                        </button>
                                                            {this.state.loading===true &&
                                                                <img className="loading" alt={"loading"}
                                                                src={loading}/>
                                                            }
                                                            </>
                                                        }

                                                    {this.state.retourEnedis!==false &&
                                                        <div className="col-12">
                                                            <br/>
                                                            <span className="msg-customer"><b>{this.state.retourEnedis}</b></span>
                                                        </div>
                                                    }
                                                        </>

                                                    }
                                                        </>
                                                    }

                                                    {(val.enedis.body.onGoingInterventions.openingLevel*1!==2) &&
                                                        <>
                                                            {((val.enedis.body.onGoingInterventions.nbrjourRestants*1<2 || (val.enedis.body.onGoingInterventions.nbrjourRestants===2 && !estAvantLimiteCancel)))&&
                                                                <div className="message-enedis">
                                                                    <span>- Il est trop tard pour faire annuler la demande de manière automatique, contactez notre service client qui contactera la Ligne Affaires Urgentes d’Enedis.</span>
                                                                </div>
                                                            }
                                                            {(
                                                                    (
                                                                        val.enedis.body.onGoingInterventions.nbrjourRestants*1>2 || (val.enedis.body.onGoingInterventions.nbrjourRestants===2 && estAvantLimiteCancel)
                                                                    )) &&
                                                                <>
                                                                    {this.state.retourEnedis===false &&
                                                                    <>
                                                                    <button id={"bloc"+val.id}
                                                                            data-request={val.enedis.body.onGoingInterventions.affaireId}
                                                                            data-typerequest={val.enedis.body.onGoingInterventions.typeRequest}
                                                                            data-id={val.id} data-contract={key} onClick={this.confirmationAction}
                                                                            className="ohm-btn-payment btn btn-send-link col-6">
                                                                        {val.enedis.body.onGoingInterventions.libelleBoutton}
                                                                    </button>
                                                                    {this.state.loading===true &&
                                                                        <img className="loading" alt={"loading"}
                                                                             src={loading}/>
                                                                    }
                                                                    </>
                                                                    }

                                                                    {this.state.retourEnedis!==false &&
                                                                        <div className="col-12">
                                                                            <br/>
                                                                            <span className="msg-customer"><b>{this.state.retourEnedis}</b></span>
                                                                        </div>
                                                                    }
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </>

                                        }
                                        {(val.enedis.body.onGoingInterventions.situationAlimentation==="Coupé" || val.enedis.body.onGoingInterventions.situationAlimentation==="Limité")&&
                                    <div>

                                            <div className="message-enedis">
                                                <span>- Le rétablissement est gratuit, aucun nouveau frais ne sera facturé.</span>
                                            </div>
                                            {val.enedis.body.onGoingInterventions.openingLevel*1===2 &&
                                            <div className="message-enedis">
                                                <span>
                                                    - Le rétablissement devrait avoir lieu quasi-instantanément.<br />
                                                    - Dans le cas d’une mauvaise communication avec le compteur, il aura lieu le lendemain. <br />
                                                    - Si ça n’est toujours pas le cas contactez notre service client. <br /> <br />
                                                </span>
                                            </div>
                                            }

                                        {val.enedis.body.onGoingInterventions.nbrDemande>0 &&
                                            <div className="col-12">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Demande en cours</th>
                                                        <th scope="col">Date d'effet</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {   val.enedis.body.onGoingInterventions.listeEncours &&
                                                    val.enedis.body.onGoingInterventions.listeEncours.map((demande, index) =>
                                                        <tr  key={index}>
                                                            <td>{demande.message}</td>
                                                            <td>{demande.date}</td>
                                                        </tr>
                                                    )

                                                }
                                                </tbody>
                                            </table>
                                            </div>

                                        }

                                        {val.enedis.body.onGoingInterventions.openingLevel*1!==2 &&
                                            <div className="message-enedis col-12">
                                                { estAvantLimite && <>
                                                <span>Le rétablissement est-il à réaliser dans la journée ?</span>
                                                <div className="col-12">
                                                    <label><input type="radio" value="oui" checked={this.state.selectedOptionRetab==='oui'} onChange={this.handleOptionChangeRetab}/>
                                                         <span className="label-enedis-radio">Oui</span>
                                                    </label>
                                                    <label><input type="radio" value="non" checked={this.state.selectedOptionRetab==='non'} onChange={this.handleOptionChangeRetab}/>
                                                        <span className="label-enedis-radio">Non</span>
                                                    </label>
                                                </div>
                                                </>
                                                }
                                                { (this.state.selectedOptionRetab==="oui" && estAvantLimite) &&
                                                <div className="message-enedis">
                                                    <span>Dans la mesure du possible un technicien d’ENEDIS devrait procéder au rétablissement dès aujourd’hui.</span>
                                                </div>
                                                }
                                                { (this.state.selectedOptionRetab==="non" || !estAvantLimite) &&
                                                    <div className="message-enedis">
                                                        <span>Un technicien d’ENEDIS devrait procéder au rétablissement à la date souhaitée. <br />Il pourra être amené à vous contactez par téléphone.</span>
                                                    </div>
                                                }

                                                <div className="col-lg-5 col-md-12 col-sm-12">
                                                    <label htmlFor="tel">Numéro de téléphone de l'occupant :</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.tel}
                                                        onChange={this.onChangeTelEnedis}
                                                    />
                                                    {this.state.errorTelEnedis &&
                                                        <div className="alert alert-danger" role="alert">
                                                            {this.state.errorTelEnedis}
                                                        </div>
                                                    }
                                                </div>
                                                {(this.state.selectedOptionRetab==="non" || !estAvantLimite) &&
                                                    <div className="col-lg-5 col-md-12 col-sm-12">
                                                        <label className="form-check-label">
                                                            Date d’effet souhaitée
                                                        </label>

                                                        <DatePicker
                                                            selected={this.state.dateEffet}
                                                            onChange={handleDateChangeEnedis}
                                                            dateFormat="dd/MM/yyyy"
                                                            required
                                                            className="form-control col-12"
                                                            placeholderText="dd/mm/yyyy"
                                                            filterDate={isWeekday}
                                                            minDate={addDays(new Date(),1)}
                                                            locale="fr"
                                                            id={"date_effet"}
                                                        />


                                                    </div>
                                                }

                                            </div>

                                        }


                                        <div className="form-group">
                                            {(this.state.retourEnedis===false && !this.state.errorTelEnedis) &&
                                                <>
                                            <button id={"bloc"+val.id}
                                                    data-request={val.enedis.body.onGoingInterventions.affaireId}
                                                    data-typerequest={val.enedis.body.onGoingInterventions.typeRequest}
                                                    data-id={val.id} data-contract={key} onClick={this.confirmationAction}
                                                    className="ohm-btn-payment btn btn-send-link col-6">{val.enedis.body.onGoingInterventions.libelleBoutton}</button>
                                            {this.state.loading===true &&
                                                <img className="loading" alt={"loading"}
                                                     src={loading}/>
                                            }
                                            </>
                                            }
                                            {this.state.retourEnedis!==false &&
                                                <div className="col-12" >
                                                <br/>
                                                    <span className="msg-customer"><b>{this.state.retourEnedis}</b></span>
                                                </div>
                                            }
                                        </div>


                                    </div>
                                        }

                                    </div>

                                }
                                { ((val.id*1===this.state.idDette*1) && (!this.state.infoEnedis) && ((this.state.displayBlockPP1===true && this.state.errorPP1===false) || val.dunning.actif>0)) &&
                                <div id={val.id} className="col-12 info-payment info-dette info-dette-active" >
                                    {this.state.displayBlockPP1===false &&
                                        <>
                                        <h3>{this.state.paymentType==="dettes" ? "Liste des éléments en dettes actives" : "Liste des factures à venir"}</h3>
                                    <div className="info-contract">

                                        <div className="dette-active">
                                            <span>{this.state.paymentType==="dettes" ? "Dettes actives" : "Total sélectionné"} :</span><span className="import"> {val.dunning.actif} &euro;</span>
                                        </div>
                                        <div className="info-table">
                                            {
                                                ( this.state.paymentType!=="dettes")&&
                                                <div>
                                                    {
                                                        this.state.loadingAnticip===true &&
                                                            <img className="loading" alt={"loading"} src={loading}/>
                                                    }

                                                </div>
                                            }
                                        <table className="table">
                                            { this.state.paymentType==="dettes" &&
                                            <thead>
                                                <tr>
                                                    <th scope="col">Type</th>
                                                    <th scope="col">Nom</th>
                                                    <th scope="col">Date</th>
                                                    <th scope="col">Montant</th>
                                                </tr>
                                            </thead>
                                            }

                                            { this.state.paymentType!=="dettes" &&
                                                <thead>
                                                <tr>
                                                    <th scope="col">Numéro de facture</th>
                                                    <th scope="col">Date de facture</th>
                                                    <th scope="col">Date d'échéance</th>
                                                    <th scope="col">Montant</th>
                                                    <th scope="col"></th>
                                                </tr>
                                                </thead>
                                            }
                                                <tbody>
                                            {   val.dunning.payment_list &&
                                                val.dunning.payment_list.map((payment, index) =>
                                                    <tr  key={index}>
                                                        <td>Paiement</td>
                                                        <td>{payment.name}</td>
                                                        <td>{payment.date}</td>
                                                        <td>{payment.residual_amount_debt} &euro;</td>
                                                    </tr>
                                                )

                                            }

                                            {

                                                val.dunning.invoice_list && this.state.paymentType==="dettes"&&
                                                val.dunning.invoice_list.map((invoice, index) =>
                                                    <tr  key={index}>
                                                        <td>Facture</td>
                                                        <td>{invoice.invoice_number}</td>
                                                        <td>{invoice.invoice_date}</td>
                                                        <td>{invoice.residual_amount_debt} &euro;</td>
                                                    </tr>
                                                )

                                            }

                                            {

                                                val.dunning.invoice_list && this.state.paymentType!=="dettes"&&
                                                val.dunning.invoice_list.map((invoice, index) =>
                                                    <tr  key={index}>
                                                        <td>{invoice.invoice_number}</td>
                                                        <td>{invoice.invoice_date}</td>
                                                        <td>{invoice.invoice_date_due}</td>
                                                        <td>{invoice.residual_amount_debt} &euro;</td>
                                                        <td><input
                                                            value={invoice.invoice_number}
                                                            data-amount={invoice.residual_amount_debt}
                                                            data-dettes={amountDetteBackup[key] > -1 ? amountDetteBackup[key] : val.dunning.actif}
                                                            data-contract = {key}
                                                            type="checkbox"
                                                            checked={this.state.listRefInvoiceAnticip.includes(invoice.invoice_number) ? true : false}
                                                            onChange={this.handleSelectInvoice}
                                                        /></td>
                                                    </tr>
                                                )

                                            }
                                                </tbody>
                                        </table>
                                        </div>
                                    </div>
                                    </>
                                    }
                                    { (this.state.errorPP1===false && this.state.displayBlockPP1===true && this.state.infoPP1 !=="") &&
                                        <div>
                                            {this.state.loadingPp1===true &&
                                                <img className="loading" alt={"loading"} src={loading}/>
                                            }
                                            {this.state.loadingPp1===false &&
                                                <h3>Montant du prélèvement : {this.state.infoPP1[1] } &euro;</h3>
                                            }
                                        </div>

                                    }

                                        <div className="info-contract">
                                        <div className="method-payment">
                                            <div className="select-paiement">
                                                <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Comment souhaitez-vous régler {this.state.displayBlockPP1===true ? "votre premier prélèvement" : (this.state.paymentType==="dettes" ? "vos dettes en cours" : "vos factures")} ?
                                                </span>
                                            </div>
                                    <div className="form-check">
                                        <div className="row option-payment">
                                            <div className={"col-lg-4 col-md-12 col-sm-12 option-payment-1 option-payment-info " + ((this.state.typePayment === "pic" && this.state.force===false) ? "valid-option" : "")}
                                                 data-methodpayment="piccb"
                                                 data-val="pic"
                                                 data-amountmaxupdate={val.dunning.actif}
                                                 onClick={this.handleOptionChangeTypePayment}
                                            >
                                                {  (this.state.typePayment === "pic" && this.state.force===false) &&
                                                    <div data-methodpayment="piccb"
                                                         data-val="pic"
                                                         data-amountmaxupdate={val.dunning.actif}
                                                         onClick={this.handleOptionChangeTypePayment}
                                                        className="option-payment-valid col-12">
                                                        <img src={valide} alt="valide" />
                                                    </div>
                                                }
                                                <div data-methodpayment="piccb"
                                                     data-val="pic"
                                                     data-amountmaxupdate={val.dunning.actif}
                                                     onClick={this.handleOptionChangeTypePayment}
                                                    className="col-12">
                                                    <span
                                                        data-methodpayment="piccb"
                                                        data-val="pic"
                                                        data-amountmaxupdate={val.dunning.actif}
                                                        onClick={this.handleOptionChangeTypePayment}
                                                    >Je préfère opter pour un</span>
                                                    <span className="option-payment-span"
                                                        data-methodpayment="piccb"
                                                        data-val="pic"
                                                        data-amountmaxupdate={val.dunning.actif}
                                                        onClick={this.handleOptionChangeTypePayment}
                                                    > <br/> {val.status ==="Actif" ? "paiement instantané complet" : "paiement instantané"}</span>
                                                </div>
                                            </div>
                                            { (val.dunning.spread.afficheEtalement===true) &&
                                                <div className={"col-lg-4 col-md-12 col-sm-12 option-payment-2 option-payment-info " + ((this.state.typePayment === "pipe" && this.state.force===false) ? "valid-option" : "")}
                                                     data-partialamount={val.dunning.partialAmount}
                                                     data-methodpayment="pipcb"
                                                     data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                     data-val="pipe"
                                                     onClick={this.handleOptionChangeTypePayment}
                                                >
                                                    {  (this.state.typePayment === "pipe" && this.state.force===false) &&
                                                        <div data-partialamount={val.dunning.partialAmount}
                                                             data-methodpayment="pipcb"
                                                             data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                             data-val="pipe"
                                                             onClick={this.handleOptionChangeTypePayment}
                                                            className="option-payment-valid col-12">
                                                            <img src={valide} alt="valide" />
                                                        </div>
                                                    }
                                                    <div data-partialamount={val.dunning.partialAmount}
                                                         data-methodpayment="pipcb"
                                                         data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                         data-val="pipe"
                                                         onClick={this.handleOptionChangeTypePayment}
                                                        className="col-12">
                                                    <span
                                                        data-partialamount={val.dunning.partialAmount}
                                                        data-methodpayment="pipcb"
                                                        data-val="pipe"
                                                        data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                        onClick={this.handleOptionChangeTypePayment}
                                                    >Je préfère opter pour un</span>
                                                    <span className="option-payment-span"
                                                          data-partialamount={val.dunning.partialAmount}
                                                          data-methodpayment="pipcb"
                                                          data-val="pipe"
                                                          data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                          onClick={this.handleOptionChangeTypePayment}
                                                    ><br/> paiement partiel immédiat <br/>et planifier l'étalement</span>
                                                </div>
                                                </div>
                                            }

                                        </div>
                                    </div>

                                            {
                                                //Début partie forcé
                                            }
                                            {(val.dunning.spread.forced_process_everyone===1 || (val.dunning.spread.forced_process_everyone===0 && (this.state.role==="ROLE_ADMIN" || this.state.role==="ROLE_SUPER_AGENT"))) &&
                                            <div className="form-check">
                                                <div className="row option-payment">
                                                    <div className={"col-lg-4 col-md-12 col-sm-12 option-payment-1 option-payment-info " + ((this.state.typePayment === "pic" && this.state.force===true) ? "valid-option" : "")}
                                                         data-methodpayment="piccb"
                                                         data-val="pic"
                                                         data-force={true}
                                                         data-amountmaxupdate={val.dunning.actif}
                                                         onClick={this.handleOptionChangeTypePayment}
                                                    >
                                                        {  (this.state.typePayment === "pic" && this.state.force===true) &&
                                                            <div data-methodpayment="piccb"
                                                                 data-val="pic"
                                                                 data-force={true}
                                                                 data-amountmaxupdate={val.dunning.actif}
                                                                 onClick={this.handleOptionChangeTypePayment}
                                                                 className="option-payment-valid col-12">
                                                                <img src={valide} alt="valide" />
                                                            </div>
                                                        }
                                                        <div data-methodpayment="piccb"
                                                             data-val="pic"
                                                             data-force={true}
                                                             data-amountmaxupdate={val.dunning.actif}
                                                             onClick={this.handleOptionChangeTypePayment}
                                                             className="col-12">
                                                    <span
                                                        data-methodpayment="piccb"
                                                        data-val="pic"
                                                        data-force={true}
                                                        data-amountmaxupdate={val.dunning.actif}
                                                        onClick={this.handleOptionChangeTypePayment}
                                                    >Je préfère opter pour un</span>
                                                            <span className="option-payment-span-force"
                                                                  data-methodpayment="piccb"
                                                                  data-val="pic"
                                                                  data-force={true}
                                                                  data-amountmaxupdate={val.dunning.actif}
                                                                  onClick={this.handleOptionChangeTypePayment}
                                                            > <br/> paiement instantané complet forcé</span>
                                                        </div>
                                                    </div>
                                                    { (val.dunning.spread.afficheEtalement===true) &&
                                                        <div className={"col-lg-4 col-md-12 col-sm-12 option-payment-2 option-payment-info " + ((this.state.typePayment === "pipe" && this.state.force===true) ? "valid-option" : "")}
                                                             data-partialamount={val.dunning.partialAmount}
                                                             data-methodpayment="pipcb"
                                                             data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nbr_max_force : val.dunning.spread.nb_max_anticipe}
                                                             data-val="pipe"
                                                             data-force={true}
                                                             onClick={this.handleOptionChangeTypePayment}
                                                        >
                                                            {  (this.state.typePayment === "pipe" && this.state.force===true) &&
                                                                <div data-partialamount={val.dunning.partialAmount}
                                                                     data-methodpayment="pipcb"
                                                                     data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nbr_max_force : val.dunning.spread.nb_max_anticipe}
                                                                     data-val="pipe"
                                                                     data-force={true}
                                                                     onClick={this.handleOptionChangeTypePayment}
                                                                     className="option-payment-valid col-12">
                                                                    <img src={valide} alt="valide" />
                                                                </div>
                                                            }
                                                            <div data-partialamount={val.dunning.partialAmount}
                                                                 data-methodpayment="pipcb"
                                                                 data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nbr_max_force : val.dunning.spread.nb_max_anticipe}
                                                                 data-val="pipe"
                                                                 data-force={true}
                                                                 onClick={this.handleOptionChangeTypePayment}
                                                                 className="col-12">
                                                    <span
                                                        data-partialamount={val.dunning.partialAmount}
                                                        data-methodpayment="pipcb"
                                                        data-force={true}
                                                        data-val="pipe"
                                                        data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nbr_max_force : val.dunning.spread.nb_max_anticipe}
                                                        onClick={this.handleOptionChangeTypePayment}
                                                    >Je préfère opter pour un</span>
                                                                <span className="option-payment-span-force"
                                                                      data-partialamount={val.dunning.partialAmount}
                                                                      data-methodpayment="pipcb"
                                                                      data-val="pipe"
                                                                      data-force={true}
                                                                      data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nbr_max_force : val.dunning.spread.nb_max_anticipe}
                                                                      onClick={this.handleOptionChangeTypePayment}
                                                                ><br/> paiement partiel immédiat <br/>et planifier l'étalement forcé</span>
                                                            </div>
                                                        </div>
                                                    }

                                                </div>
                                            </div>
                                            }
                                            {
                                                //Fin partie forcé
                                            }

                                            { this.state.typePayment==="pic" &&
                                                <>
                                                {(val.status ==="Terminé" || this.state.force===true) &&
                                                    <>
                                                <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Paramètres du paiement instantané
                                                </span>
                                                        <div className={"row option-payment info-amount-update col-lg-4 col-md-12 col-sm-12 option-payment-1 option-payment-info valid-option"}>
                                                            <div className=" col-lg-4 col-md-12 col-sm-12">
                                                                <label className="montant-partiel" htmlFor="montant">Montant</label>
                                                            </div>
                                                            <div  className="row col-lg-7 col-md-12 col-sm-12 input-amount-div">
                                                            {(val.status ==="Terminé" && this.state.force===false) &&
                                                            <>
                                                            <input
                                                                disabled={this.state.amountvalid}
                                                                type="text"
                                                                className="form-control input-amount col-9"
                                                                name="montant"
                                                                data-amounttotal={val.dunning.actif}
                                                                data-amountmin={val.dunning.spread.ct_ter_mt_min}
                                                                defaultValue={val.dunning.actif}
                                                                onChange={this.onChangeAmountUpdate}
                                                            /> <span className="devis-input-amount col-3"> &euro;</span>
                                                            </>
                                                            }

                                                            {this.state.force===true &&
                                                                <select className="form-control info-montant-partiel col-9" onChange={this.onChangeAmountUpdate}>
                                                                    {   val.dunning.spread_payment_force &&
                                                                        val.dunning.spread_payment_force.map((elt, index) =>
                                                                            <option  data-nbrmax={elt.nb_max}
                                                                                     data-amounttotal={val.dunning.actif}
                                                                                     value={elt.amount}
                                                                                     selected={elt.amount===val.dunning.actif ? true : ""}  key={index}>{elt.amount} &euro;</option>
                                                                        )

                                                                    }
                                                                </select>



                                                            }
                                                            </div>
                                                        </div>
                                                        {this.state.errorMsgUpdateAmount &&
                                                        <div className="alert alert-danger" role="alert">
                                                            {this.state.errorMsgUpdateAmount}
                                                        </div>
                                                        }
                                                        {this.state.valideMsgUpdateAmount &&
                                                            <div className="alert alert-success" role="alert">
                                                                {this.state.valideMsgUpdateAmount}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                                { (this.state.errorMsgUpdateAmount==="")&&
                                                <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Moyens de paiement
                                                </span>
                                                }

                                                </>
                                            }
                                            { (val.dunning.partialAmount>0 && this.state.typePayment==="pipe")&&
                                                <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Paramètres du paiement instantané
                                                </span>
                                            }

                                            { (val.dunning.partialAmount>0)&& (this.state.typePayment==="pipe") &&
                                                <>
                                                {
                                                    (this.state.force===false) &&
                                                        <div className="row" id="pip">
                                                            <RcSlider parentFunction={this.handleOptionChangeInfoEtalement} nbrMaxSpreadForce={this.recevoirNbrMaxSpreadForce} amountSpreadForce={this.recevoirValeurAmountSpreadForce} amountvalid={this.state.amountvalid}   listNbrSpread = {val.dunning.spread_force_list_nbetal} listValueAmount = {val.dunning.spread_force_list_amount} defaultVal = {val.dunning.partialAmount} minVal={val.dunning.spread_force_list_amount[0]} maxVal={val.dunning.spread_force_list_amount[val.dunning.spread_force_list_amount.length-1]}/>
                                                        </div>


                                                }
                                                    {this.state.force===true &&
                                                        <>
                                                        <div className={"row option-payment info-amount-update col-lg-4 col-md-12 col-sm-12 option-payment-1 option-payment-info valid-option"}>
                                                            <div className=" col-lg-4 col-md-12 col-sm-12">
                                                                <label className="montant-partiel" htmlFor="montant">Montant</label>
                                                            </div>
                                                            <div  className="row col-lg-7 col-md-12 col-sm-12 input-amount-div">
                                                        <select className="form-control info-montant-partiel col-9" onChange={this.handleOptionChangeInfoEtalementForce}>
                                                            {   val.dunning.spread_payment_force &&
                                                                val.dunning.spread_payment_force.map((elt, index) =>
                                                                    <option  data-nbrmax={elt.nb_max}
                                                                             data-amounttotal={val.dunning.actif}
                                                                             value={elt.amount}
                                                                             selected={elt.amount===val.dunning.actif ? true : ""}  key={index}>{elt.amount} &euro;</option>
                                                                )

                                                            }
                                                        </select>
                                                        </div>
                                                        </div>
                                                        </>



                                                    }
                                                </>


                                            }

                                            { ((this.state.typePayment === "pic" || this.state.typePayment==="pipe") && (this.state.errorMsgUpdateAmount==="")) &&
                                                <div className={"form-check "}>
                                                <div className={"option-payment row"}>
                                                    <div  className={"col-lg-4 col-md-12 col-sm-12 option-payment-1 option-payment-info " + ((this.state.methodPayment === "piccb" || this.state.methodPayment === "pipcb") ? "valid-option" : "")}
                                                          data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                          data-amountmaxupdate={val.dunning.actif}
                                                          data-nbretal={nbrEtal}
                                                          data-partialamount={this.state.partialAmount}
                                                          data-force={this.state.force}
                                                          onClick={this.handleOptionChangeTypePayment} >
                                                        {(this.state.methodPayment==="piccb" || this.state.methodPayment==="pipcb") &&
                                                        <div data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                             className="option-payment-valid col-12"
                                                             data-nbretal={nbrEtal}
                                                             data-amountmaxupdate={val.dunning.actif}
                                                             data-force={this.state.force}
                                                             data-partialamount={this.state.partialAmount}
                                                             onClick={this.handleOptionChangeTypePayment}>
                                                            <img src={valide} alt="valide" />
                                                        </div>
                                                        }
                                                        <div
                                                            className="col-12 moyen-payment "
                                                            data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                            data-nbretal={nbrEtal}
                                                            data-amountmaxupdate={val.dunning.actif}
                                                            data-force={this.state.force}
                                                            data-partialamount={this.state.partialAmount}
                                                            onClick={this.handleOptionChangeTypePayment}>
                                                            <div data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                 data-amountmaxupdate={val.dunning.actif}
                                                                 data-nbretal={nbrEtal}
                                                                 data-force={this.state.force}
                                                                 data-partialamount={this.state.partialAmount}
                                                                 onClick={this.handleOptionChangeTypePayment}>
                                                                <span
                                                                    data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                    data-amountmaxupdate={val.dunning.actif}
                                                                    data-nbretal={nbrEtal}
                                                                    data-partialamount={this.state.partialAmount}
                                                                    data-force={this.state.force}
                                                                    onClick={this.handleOptionChangeTypePayment}>
                                                                    Paiement par<br/></span>
                                                                <span className="option-payment-span"
                                                                      data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                      data-partialamount={this.state.partialAmount}
                                                                      data-amountmaxupdate={val.dunning.actif}
                                                                      data-nbretal={nbrEtal}
                                                                      data-force={this.state.force}
                                                                      onClick={this.handleOptionChangeTypePayment}>Carte bancaire</span>
                                                            </div>
                                                            <div className="moyen-payment-cb"
                                                                 data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                 data-partialamount={this.state.partialAmount}
                                                                 data-amountmaxupdate={val.dunning.actif}
                                                                 data-force={this.state.force}
                                                                 data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                                 onClick={this.handleOptionChangeTypePayment}>
                                                                <img className="logocb"
                                                                     data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                     data-partialamount={this.state.partialAmount}
                                                                     data-nbretal={nbrEtal}
                                                                     data-amountmaxupdate={val.dunning.actif}
                                                                     data-force={this.state.force}
                                                                     onClick={this.handleOptionChangeTypePayment} alt={"CB"} src={cb}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    { ((val.dunning.spread.prelemvementAuto===true || (val.dunning.spread.prelemvementAutoAnticipe && this.state.paymentType==='anticipe')) || this.state.typePayment === "pic") &&
                                                    <div
                                                        className={"col-lg-4 col-md-12 col-sm-12 option-payment-2 option-payment-info "+ ((this.state.methodPayment === "picvir" || this.state.methodPayment === "pipvir") ? "valid-option" : "")}
                                                        data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                        data-partialamount={this.state.partialAmount}
                                                        data-amountmaxupdate={val.dunning.actif}
                                                        onClick={this.handleOptionChangeTypePayment}>
                                                        { (this.state.methodPayment==="picvir" || this.state.methodPayment==="pipvir") &&
                                                        <div className="option-payment-valid col-12"
                                                             data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                             data-partialamount={this.state.partialAmount}
                                                             data-amountmaxupdate={val.dunning.actif}
                                                             data-nbretal={nbrEtal}
                                                             data-force={this.state.force}
                                                             title={"Payez directement depuis votre application bancaire avec notre partenaire Slimpay"}
                                                             onClick={this.handleOptionChangeTypePayment}>
                                                            <img src={valide} alt="valide" />
                                                        </div>
                                                        }
                                                        <div className="col-12 moyen-payment "
                                                             data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                             data-partialamount={this.state.partialAmount}
                                                             data-amountmaxupdate={val.dunning.actif}
                                                             data-nbretal={nbrEtal}
                                                             data-force={this.state.force}
                                                             onClick={this.handleOptionChangeTypePayment}
                                                             title={"Payez directement depuis votre application bancaire avec notre partenaire Slimpay"}
                                                        >
                                                            <div
                                                                data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                data-amountmaxupdate={val.dunning.actif}
                                                                data-partialamount={this.state.partialAmount}
                                                                data-nbretal={nbrEtal}
                                                                data-force={this.state.force}
                                                                onClick={this.handleOptionChangeTypePayment}
                                                                title={"Payez directement depuis votre application bancaire avec notre partenaire Slimpay"}
                                                                >
                                                                <span
                                                                    data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                    title={"Payez directement depuis votre application bancaire avec notre partenaire Slimpay"}
                                                                    data-amountmaxupdate={val.dunning.actif}
                                                                    data-partialamount={this.state.partialAmount}
                                                                    data-nbretal={nbrEtal}
                                                                    data-force={this.state.force}
                                                                    onClick={this.handleOptionChangeTypePayment}>
                                                                    Payer avec ma banque<br/>
                                                                </span>
                                                                <span
                                                                    className="option-payment-span"
                                                                    title={"Payez directement depuis votre application bancaire avec notre partenaire Slimpay"}
                                                                    data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                    data-amountmaxupdate={val.dunning.actif}
                                                                    data-nbretal={nbrEtal}
                                                                    data-force={this.state.force}
                                                                    data-partialamount={this.state.partialAmount}
                                                                    onClick={this.handleOptionChangeTypePayment}>Simple, rapide et sécurisé
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }
                                                </div>
                                                </div>

                                            }

                                            { (val.dunning.partialAmount>0 && this.state.typePayment==="pipe" && (this.state.methodPayment==="pipcb" || this.state.methodPayment==="pipvir") )&&
                                                <>
                                                <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Paramètres de l'étalement
                                                </span>

                                                <div className="form-check">
                                                <div className="row option-payment">
                                                    { val.dunning.spread.prelemvementAuto===true &&
                                                    <div onClick={this.handleOptionChangeMethodEtalement} data-val="sdd" className={"option-payment-1  valid-option col-lg-4 col-md-12 col-sm-12 option-payment-2 option-payment-info"}>

                                                        { this.state.methodPaymentEtalement==="sdd" &&
                                                            <div onClick={this.handleOptionChangeMethodEtalement} data-val="sdd"
                                                                className="option-payment-valid col-12">
                                                                <img src={valide} alt="valide" />
                                                            </div>
                                                        }

                                                            <div className="col-12 moyen-payment"
                                                                 onClick={this.handleOptionChangeMethodEtalement} data-val="sdd">
                                                                <span data-val="sdd">Prélèvement automatique</span>
                                                            </div>
                                                    </div>
                                                    }
                                                    { (this.state.methodPayment!=="pipvir")&&
                                                    <div data-val="cb"
                                                         onClick={this.handleOptionChangeMethodEtalement}
                                                         className={"valid-option col-lg-4 col-md-12 col-sm-12 option-payment-2 option-payment-info "}>
                                                        { this.state.methodPaymentEtalement==="cb" &&
                                                            <div onClick={this.handleOptionChangeMethodEtalement} data-val="cb"
                                                                className="col-12 option-payment-valid">
                                                                <img src={valide} alt="valide" />
                                                            </div>
                                                        }
                                                        <div onClick={this.handleOptionChangeMethodEtalement}  data-val="cb"
                                                            className="col-12 moyen-payment ">
                                                        <div onClick={this.handleOptionChangeMethodEtalement}
                                                            data-val="cb">
                                                            <span data-val="cb">Paiement par<br/></span>
                                                            <span data-val="cb" className="option-payment-span">Carte bancaire</span>
                                                        </div>
                                                        <div onClick={this.handleOptionChangeMethodEtalement}
                                                            data-val="cb" className="moyen-payment-cb">
                                                            <img data-val="cb" className="logocb" alt={"CB"} src={cb}/>
                                                        </div>
                                                        </div>

                                                    </div>

                                                    }
                                                </div>
                                                </div>
                                                </>
                                            }

                                            { (val.dunning.partialAmount>0 && this.state.methodPaymentEtalement!=="")&&
                                                <div className="form-check">
                                                { (this.state.typePayment==="pipe") &&
                                                    <div className="form-check" id="pip">
                                                        <div className="row">
                                                            <div className="col-lg-4 col-md-12 col-sm-12">
                                                                <label className="form-check-label">
                                                                    Nombre d’étalements
                                                                </label>
                                                                    <select disabled={this.state.amountvalid}
                                                                        onChange={this.handleOptionChangeNbrEtalement}
                                                                        className="form-control col-12">
                                                                        {function() {
                                                                        let options = []
                                                                        for (let i = 1; i<=nbrEtal; i++){
                                                                            options.push(<option value={i}>{i}</option>)
                                                                        }
                                                                        return options
                                                                            }()
                                                                        }
                                                                    </select>
                                                            </div>
                                                            <div className="col-lg-5 col-md-12 col-sm-12">
                                                                <label className="form-check-label">
                                                                    Date du premier prélèvement
                                                                </label>

                                                                <DatePicker
                                                                    selected={this.state.startDate}
                                                                    onChange={handleDateChange}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    required
                                                                    disabled={this.state.amountvalid}
                                                                    className="form-control col-12"
                                                                    placeholderText="dd/mm/yyyy"
                                                                    filterDate={isWeekday}
                                                                    minDate={addDays(new Date(), 1)}
                                                                    maxDate={addDays(new Date(), this.state.paymentType === "dettes" ? val.dunning.spread.nbrDayMax : val.dunning.spread.nbrDayMaxAnticipe)}
                                                                    locale="fr"
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            }
                                            {(((this.state.typePayment==="pipe" && this.state.methodPaymentEtalement!=="") || this.state.typePayment==="pic" ) && (this.state.errorMsgUpdateAmount==="")) &&
                                                <>
                                                <span><br/>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Auriez-vous un commentaire dont vous voudriez nous faire part ? </span>
                                                {this.state.force===false ? <span>(Facultatif)</span> : <span className='option-payment-span-force'>(Obligatoire Minimum 10 caractères)</span> }

                                                <div className="col-12">
                                                    <textarea onChange={this.handleTextareaChange} className="col-12 text-comment"></textarea>
                                                </div>
                                                </>
                                            }
                                        </div>
                                        { (infoEtalementTab && this.state.infoEtalement && this.state.methodPaymentEtalement!=="") &&
                                            <div className="info-table-etalement">
                                                <table className="table">
                                                    <thead>
                                                    <tr>
                                                        <th scope="col">Date du prélèvement</th>
                                                        <th scope="col">Montant prélevé total</th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {   infoEtalementTab &&
                                                        infoEtalementTab.map((payment, index) =>

                                                            (payment.parent===this.state.parent ||  payment.name==='total')?
                                                                <tr className ={payment.name==='total' ? "tr-total" : "tr-detail"} key={index}>

                                                                <td>{
                                                                    payment.name==='total' ?
                                                                    <span>{payment.datepayment} {payment.datepayment === format(new Date(),"dd/MM/yyyy") ? "(Aujourd'hui)" : ""}</span>
                                                                    : payment.name
                                                                }</td>
                                                                <td>{payment.name==='total' ? <span>{payment.amount} &euro;</span> : <span>{payment.amount} &euro;</span>} </td>
                                                                <td>{payment.name==='total' ? <button data-parent={payment.parent} onClick={this.viewList}>+</button> : ""} </td>
                                                            </tr> : ""

                                                        )

                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        }
                                        { ((this.state.countComment>=10 && this.state.force===true) || (this.state.force===false))&&
                                        <div id="btn-payment">
                                        { ((this.state.methodPayment==="piccb" || this.state.methodPayment==="picvir" || ((this.state.methodPayment==="pipcb" || this.state.methodPayment==="pipvir") && this.state.methodPaymentEtalement!=="")) && (this.state.errorMsgUpdateAmount==="")) &&
                                            <div>
                                                <div className="col-12">
                                                    <button onClick={this.sendLink} className="ohm-btn-payment btn btn-send-link col-11">Paiement : envoyer le lien</button>
                                                </div>
                                                <div className="col-12">
                                                    <button onClick={this.seeLink} className="ohm-btn-payment btn btn-link col-lg-3 col-md-11 col-sm-11">Liste des liens envoyés au client</button>
                                                    <button onClick={this.reportPayment} className="ohm-btn-payment btn btn-list col-lg-3 col-md-11 col-sm-11">Rapport des paiements</button>
                                                    {(this.state.methodPayment!=="picvir" && this.state.methodPayment!=="pipvir") &&
                                                        <button onClick={this.payment} className="ohm-btn-payment btn btn-payment col-lg-4 col-md-11 col-sm-11">Prendre le paiement (obsolète, à utiliser uniquement en dernier recours) </button>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        </div>
                                        }

                                    </div>
                                </div>
                                }
                                <div ref={key===0 ? this.blockRef0 : this.blockRef1}></div>
                            </div>
                        )
                    })}

                    <ReactModal
                        isOpen={this.state.isOpen}
                        contentLabel="Modal info carte"
                        className="custom-modal"
                    >
                            <div id="modal" className="content-modal">
                                <div className="close-modal">
                                    <button onClick={this.closePopup} type="button" className=" btn-ohm btn btn-primary" aria-label="Close">X</button>
                                </div>
                                <iframe id="iframeWorldline"  title={"Iframe Worldline"} src="iframeFile/iframe.html" allowFullScreen></iframe>

                            </div>

                    </ReactModal>
                    <ReactModal
                        isOpen={this.state.isOpenSeeLink}
                        contentLabel="Modal list link"
                        className="link-modal"
                    >
                        <div id="modal" className="content-modal">
                            <div className="close-modal">
                                <button onClick={this.closePopupLink} type="button" className=" btn-ohm btn btn-primary" aria-label="Close">X</button>
                            </div>
                            <div className="container-info">
                                {this.state.listlink===false &&
                                <div>
                                        <img className="loading" alt={"loading"} src={loading}/>
                                </div>
                                }
                                {this.state.listlink && (
                                <table className="table">
                                    <thead>
                                    <tr>
                                        <th scope="col">Lien</th>
                                        <th scope="col">Expire le</th>
                                        <th scope="col">Email ou SMS</th>
                                        <th scope="col">Statut</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.listlink.map((link, index) =>
                                        <tr>
                                            <td>
                                                { (link.methodPaiment==="piccb" || link.methodPaiment==="pipcb")&&
                                                    <a target="_blank" rel="noopener noreferrer" href={"payment/&token=" + link.token}>{link.token}</a>
                                                }
                                                { (link.methodPaiment==="picvir" || link.methodPaiment==="pipvir")&&
                                                    <a target="_blank" rel="noopener noreferrer" href={"https://proxy-slimcollect.preprod.slimpay.com/pis/" + link.token.split('/')[2]}>{link.token.split('/')[2]}</a>
                                                }
                                            </td>
                                            <td>{link.disableAt}</td>
                                            <td>{link.sendWith === "EMAIL" ? "Email : " + link.email : "SMS: " + link.tel}</td>
                                            <td>{(link.status===true && moment(link.disableAt, 'DD/MM/YYYY HH:mm:ss').toDate() >= new Date()) ? "Valide" : "Expiré"}</td>
                                            <td>
                                                {(link.status===true && moment(link.disableAt, 'DD/MM/YYYY HH:mm:ss').toDate() >= new Date()) && (
                                                    <div className="send-email">
                                                    <button type="button" data-token={link.token} className=" btn-ohm btn btn-primary" onClick={this.sendBackLink}>Renvoyer le lien au client</button>
                                                        { this.state.sendMail &&
                                                            <img className="loading" alt={"loading"}
                                                            src={loading}/>
                                                        }
                                                    </div>   )
                                                }
                                            </td>
                                        </tr>
                                    )
                                    }
                                    </tbody>
                                </table>)}
                            </div>

                        </div>

                    </ReactModal>

                    <ReactModal
                        isOpen={this.state.isOpenSeePayment}
                        contentLabel="Modal list payment"
                        className="payment-modal"
                    >
                        <div id="modal" className="content-modal">
                            <div className="close-modal">
                                <button onClick={this.closePopupListPayment} type="button" className=" btn-ohm btn btn-primary" aria-label="Close">X</button>
                            </div>
                            {this.state.messageError && (
                            <div className="col-12 message-modal">
                                <p>Un problème est survenu, il faut :</p>
                                <ul>
                                    <li>Prévenir le client que “les informations ne seront pas mis à jour instantanément, que nous allons traiter ça vite et que d’ici 2 jours les informations seront mise à jour.”</li>
                                    <li>Prévenir un superviseur</li>
                                </ul>
                            </div>)}
                            <div className="col-12">
                                <h2 className="titre-modal">Rapport de création des paiements</h2>
                            </div>
                            <div className="row list-payment">
                                {this.state.listPaymentWl===false &&
                                    <div className="col-12">
                                        <img className="loading" alt={"loading"} src={loading}/>
                                    </div>
                                }
                                {this.state.listPaymentWl && (
                                    <div className="col-12">
                                        <h3>Status des paiements Worldline créé </h3>
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th scope="col">Nom de paiement</th>
                                            <th scope="col">Montant</th>
                                            <th scope="col">Satut</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.listPaymentWl.map((paymentWl, index) =>
                                            <tr>
                                                <td>{paymentWl.name}</td>
                                                <td>{paymentWl.amount}</td>
                                                <td><span className={paymentWl.status === "Echec" ? "error-payment" : "valide-payment"}>{paymentWl.status}</span></td>

                                            </tr>
                                        )
                                        }
                                        </tbody>
                                    </table>
                                    </div>)}
                            </div>
                            <div className="row list-payment">
                                {this.state.listPaymentOdoo && (
                                    <div className="col-12">
                                        <h3>Status des paiements Odoo créé</h3>
                                        <table className="table">
                                            <thead>
                                            <tr>
                                                <th scope="col">Nom de paiement</th>
                                                <th scope="col">Type de paiement</th>
                                                <th scope="col">Montant</th>
                                                <th scope="col">Satut</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.state.listPaymentOdoo.map((paymentOdoo, index) =>
                                                <tr>
                                                    <td>{paymentOdoo.name}</td>
                                                    <td>{paymentOdoo.type}</td>
                                                    <td>{paymentOdoo.amount}</td>
                                                    <td><span className={paymentOdoo.status === "Echec" ? "error-payment" : "valide-payment"}>{paymentOdoo.status}</span></td>
                                                </tr>
                                            )
                                            }
                                            </tbody>
                                        </table>
                                    </div>)}
                            </div>

                            <div className="row list-payment">
                                {this.state.listPaymentPis && (
                                    <div className="col-12">
                                        <h3>Status des paiements PIS créé</h3>
                                        <table className="table">
                                            <thead>
                                            <tr>
                                                <th scope="col">Nom de paiement</th>
                                                <th scope="col">Type de paiement</th>
                                                <th scope="col">Montant</th>
                                                <th scope="col">Satut</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.state.listPaymentPis.map((paymentPis, index) =>
                                                <tr>
                                                    <td>{paymentPis.name}</td>
                                                    <td>{paymentPis.type}</td>
                                                    <td>{paymentPis.amount}</td>
                                                    <td><span className={paymentPis.status === "Echec" ? "error-payment" : "valide-payment"}>{paymentPis.status}</span></td>
                                                </tr>
                                            )
                                            }
                                            </tbody>
                                        </table>
                                    </div>)}
                            </div>

                        </div>

                    </ReactModal>


                    <ReactModal
                        isOpen={this.state.isOpenInfo}
                        contentLabel="Modal info customer"
                        className="custom-modal-info"
                    >
                        <div id="modal-info-customer" className="content-modal">
                            <div className="close-modal">
                                <button onClick={this.closePopupInfo} type="button" className=" btn-ohm btn btn-primary" aria-label="Close">X</button>
                            </div>
                            <div className="container-info">
                                {this.state.sendLink && (
                                <Form
                                    onSubmit={this.handleAction}
                                    className={"form-info"}
                                    ref={c => {
                                        this.form = c;
                                    }}
                                >
                                    <label htmlFor="par">Envoyer le lien au client par :</label>
                                <div className="form-group">
                                    <select className="form-control" name="par" onChange={this.handleOptionChangeSend}>
                                        <option value="-" >-</option>
                                        <option value="EMAIL" >Email</option>
                                        <option value="SMS" >SMS</option>
                                    </select>
                                </div>
                                    {this.state.sendWith==="SMS" &&(
                                <div className="form-group">
                                    <label htmlFor="tel">Numéro de téléphone</label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        name="tel"
                                        value={this.state.tel}
                                        onChange={this.onChangeTel}
                                        validations={[required, tel]}
                                    />
                                </div>
                                    )
                                    }
                                    {this.state.sendWith==="EMAIL" &&(
                                <div className="form-group">
                                    <label htmlFor="email">Email</label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        name="email"
                                        value={this.state.email}
                                        onChange={this.onChangeEmail}
                                        validations={[required, email]}
                                    />
                                </div>
                                        )
                                    }
                                    {(this.state.sendWith!=="-")&&(
                                    <div className="form-group">
                                        <button className="btn-ohm btn btn-primary btn-block" >Envoyer</button>
                                        {this.state.loading===true &&
                                        <img className="loading" alt={"loading"}
                                             src={loading}/>
                                        }
                                    </div>
                                    )}
                                    <CheckButton
                                        style={{ display: "none" }}
                                        ref={c => {
                                            this.checkBtn = c;
                                        }}
                                    />
                            </Form>)
                                }

                                {this.state.sendLink===false && (
                                    <h3 className={this.state.classmessage}>{this.state.message}</h3>
                                )}
                            </div>

                        </div>

                    </ReactModal>

                </div>
                }
            </div>

        );

    }

}
